import API_ROUTES from 'services/apiRoutes';
import { buildQueryParams } from 'helpers/utils';
import { IShoppingCartSearchConfig, getShoppingCartProps } from 'store/shopping_cart/types';
import { IRecipient, IRecipientSearchResult } from 'store/recipients/types';
import { siteApi } from './siteApi';

export type RecipientWithMatchScore = IRecipient & { match_score: number | null };

export const shoppingCartApi = siteApi.injectEndpoints({
  endpoints: builder => ({
    fuzzySearchCartRecipients: builder.query<
      { recipients: RecipientWithMatchScore[]; query_was_broadened: boolean },
      getShoppingCartProps
    >({
      query: ({
        client_id,
        slates,
        states,
        organization_types,
        local_offices,
        state_offices,
        federal_offices,
        recipient_filter_categories,
        q,
        includeDefaults,
      }) => {
        const params = buildQueryParams({
          client_id,
          slates,
          states,
          organization_types,
          local_offices,
          state_offices,
          federal_offices,
          recipient_filter_categories,
          q,
          include_defaults: includeDefaults,
        });
        return `${API_ROUTES.GET_SHOPPING_CART_RECIPIENTS_FUZZY_SEARCH(params)}`;
      },
      transformResponse: (response: {
        results: IRecipientSearchResult[];
        query_was_broadened: boolean;
      }) => ({
        recipients: (response.results ?? []).map(r => ({
          ...r.recipient,
          match_score: r.query_metadata?.match_score ?? null,
        })),
        query_was_broadened: response.query_was_broadened ?? false,
      }),
      providesTags: ['ShoppingCartFuzzySearch', 'ShoppingCartSearch'],
    }),
    getShoppingCartSearchConfig: builder.query<IShoppingCartSearchConfig, { client_id: number }>({
      query: ({ client_id }) => {
        const params = buildQueryParams({
          client_id,
        });
        return `${API_ROUTES.GET_SHOPPING_CART_SEARCH_CONFIG(params)}`;
      },
      providesTags: ['ShoppingCartFuzzySearch', 'ShoppingCartSearchConfig', 'ShoppingCartSearch'],
    }),
  }),
  overrideExisting: 'throw',
});

export const {
  useFuzzySearchCartRecipientsQuery,
  useLazyFuzzySearchCartRecipientsQuery,
  useGetShoppingCartSearchConfigQuery,
} = shoppingCartApi;
